<template>
    <form action="/doneren" method="GET">
        <input type="text" name="name" placeholder="Voornaam" />
        <input type="text" name="surname" placeholder="Achternaam" />
        <ul class="prize_list">
            <li>
                <button
                    @click="selectAmount(5)"
                    type="button"
                    class="bg--primary"
                    :class="{'active': amount === 5}"
                >€5</button>
            </li>
            <li>
                <button
                    @click="selectAmount(10)"
                    type="button"
                    class="bg--primary"
                    :class="{'active': amount === 10}"
                >€10</button>
            </li>
            <li>
                <button
                    @click="selectAmount(20)"
                    type="button"
                    class="bg--primary"
                    :class="{'active': amount === 20}"
                >€20</button>
            </li>
            <li>
                <button
                    @click="selectAmount(50)"
                    type="button"
                    class="bg--primary"
                    :class="{'active': amount === 50}"
                >€50</button>
            </li>
        </ul>
        <input type="hidden" name="amount" v-model="amount" />
        <input type="submit" name class="btn_2" value="DONEER" />
    </form>
</template>
<script>
export default {
    data: function() {
        return {
            amount: ""
        };
    },
    methods: {
        selectAmount: function(amount) {
            this.amount = amount;
        }
    }
};
</script>
<style lang="scss" scoped>
.active {
    background: #fff;
    color: #e88a1b;
}
</style>